export const SET_PARAMETER_LIST = 'SET_PARAMETER_LIST';
export const ADD_PARAMETER = 'ADD_PARAMETER';
export const UPDATE_PARAMETER = 'UPDATE_PARAMETER';
export const DELETE_PARAMETER = 'DELETE_PARAMETER';



// WEBPACK FOOTER //
// ./src/parameter/parameterActionTypes.js